export const PAYROLLS_TAG_EVENTS = {
  CREATED_PAYROLL: 'PayrollAdded',
  DELETED_PAYROLL: 'PayrollRegisterDeleted',
  CLOSED_PAYROLL: 'PayrollClosed',
  OPENED_PAYROLL: 'PayrollOpened',
  CREATED_PAYROLL_CONCEPT: 'PayrollConceptAdded',
  CREATED_PAYROLL_FORMULA_CONCEPT: 'PayrollFormulaConceptAdded',
  DELETED_PAYROLL_CONCEPT: 'PayrollConceptDeleted',
  CREATED_MIRROR_PAYROLL: 'MirrorPayrollCreated',
};
